import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input, inject } from '@angular/core';
import { UiBreadcrumbComponent } from '@big-direkt/ui/breadcrumb';
import { UiLinkModule } from '@big-direkt/ui/link';
import { EnvironmentService } from '@big-direkt/utils/environment';
import { IconBigBoldGesperrterContent, IconComponent } from '@big-direkt/utils/icons';
import { TranslocoDirective } from '@jsverse/transloco';
import { type SearchResultItem } from '../../../models/search-result-item';
import { HighlightPipe } from '../../../pipes/highlight.pipe';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [HighlightPipe, IconComponent, NgClass, TranslocoDirective, UiBreadcrumbComponent, UiLinkModule],
    selector: 'big-search-result-item',
    templateUrl: './result-item.component.html',
})
export class ResultItemComponent {
    private readonly environmentService = inject(EnvironmentService);
    public readonly myBigIcon = IconBigBoldGesperrterContent;

    @HostBinding('class') @Input() public classList = 'block';
    @Input({ required: true }) public item!: SearchResultItem;
    @Input() public highlightString?: string;

    public get isPrivateUrl(): boolean {
        return this.item.breadcrumb[0]?.uri.includes(this.environmentService.privatePath);
    }
}
